/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-17 16:23:57
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/NumberInput/type.ts
 */
export enum EnumMode {
  general = 'general',
  int = 'int',
  money = 'money',
  moneyOff = 'moneyOff',
  moneyDeduction = 'moneyDeduction',
}
